<template>
    <div id="category-index" class="is-relative">
        <b-loading :active="loading" :is-full-page="false"></b-loading>
        <top-section>
            Categories
            <template v-slot:buttons>
                <b-button tag="router-link"
                          to="/atelierCategory/index"
                          type="is-primary"
                          class="is-uppercase"
                          label="Mapping Atelier categories"></b-button>
            </template>
        </top-section>

        <category-form-wrapper
            v-if="category.id || creating"
            :creating="creating"
            :parent-id="parseInt(parentId)"
            :category="category" @updated="categoryUpdated"></category-form-wrapper>

        <portal to="sidebar">
            <category-tree :refresh="sidebarRefresh"
                           @refreshed="sidebarRefresh = false"
                           :parent-id="creating ? parseInt(parentId) : parseInt(category.id)"></category-tree>
        </portal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                category: {},
                creating: false,
                parentId: 1,
                sidebarRefresh: false
            }
        },
        mounted() {
            this.setup();
        },
        methods: {
            setup() {
                this.loading = true;
                let categoryId = 1;
                if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
                    if (this.$route.params.action === 'create') {
                        this.parentId = this.$route.params.routeKey;
                        this.creating = true;
                        this.loading = false;
                        this.category = {};
                        return;
                    }
                    if (this.$route.params.action === 'edit') {
                        this.creating = false;
                        categoryId = this.$route.params.routeKey;
                    }
                }

                axios.get(`/category/edit/${categoryId}`)
                    .then(response => {
                        this.category = response.data
                        this.loading = false
                    })
            },
            categoryUpdated(category) {
                this.sidebarRefresh = true
                this.category = Object.assign({}, category);
                this.creating = false
            }
        },
        watch: {
            $route() {
                this.setup();
            }
        }
    }
</script>
